
function BreakpointChecker()
{
    this.breakpoints = this.setBreakpoints();

    // function breakpointResizeHandler()
    // {
    //     breakpoints = new BreakpointChecker();
    // }
    // // instant resize listener (not debounced)
    // window.addEventListener('resize', breakpointResizeHandler);
}


BreakpointChecker.prototype.setBreakpoints = function() {
    const breakpoints = {
        xxl: window.matchMedia("only screen and (min-width: 1400px)").matches,
         xl: window.matchMedia("only screen and (min-width: 1200px)").matches,
         lg: window.matchMedia("only screen and (min-width: 992px)").matches,
         md: window.matchMedia("only screen and (min-width: 768px)").matches,
         sm: window.matchMedia("only screen and (min-width: 576px)").matches,
         xs: window.matchMedia("only screen and (max-width: 575.98px)").matches
    }

    return breakpoints;
}

BreakpointChecker.prototype.getCurrent = function() {
    for (const [key, value] of Object.entries(this.breakpoints)) {
        if (value === true) {
            return key;
        }
    }

    return null;
}

BreakpointChecker.prototype.isBreakpoint = function(breakpoint) {
    if (this.breakpoints.hasOwnProperty(breakpoint)) {
        return this.breakpoints[breakpoint]
    }

    return false;
}

export default BreakpointChecker;
